import DOMPurify from 'dompurify';

import { dispatchCustomEvent } from './utilities/custom-events';

const defaultValues = {
    cat: {
        name: 'none',
        classic: '',
        premier: '',
        inspire: ''
    },
    cell: {
        type: 'none',
        value: ''
    },
    lgc: {
        campaignId: 'none',
        classic: '',
        premier: '',
        inspire: ''
    },
    spid: {
        campaignId: 'none',
        classic: '',
        premier: '',
        inspire: ''
    }
};

const sessionStorageKeys = {
    cat: 'disneyrewards_cat',
    cell: 'disneyrewards_cell',
    lgc: 'disneyrewards_lgc',
    spid: 'disneyrewards_spid',
};

/**
 * The current CAT (Card Art) code as stored in session storage.
 * @returns {object} Returns an object containing the CAT data.
 */
function getCat() {
    const storage = window.sessionStorage.getItem(sessionStorageKeys.cat);
    return storage !== null ? JSON.parse(DOMPurify.sanitize(storage)) : defaultValues.cat;
}

/**
 * The current CELL code as stored in session storage.
 * @returns {object} Returns an object containing the CELL code data.
 */
function getCell() {
    const storage = window.sessionStorage.getItem(sessionStorageKeys.cell);
    return storage !== null ? JSON.parse(DOMPurify.sanitize(storage)) : defaultValues.cell;
}

/**
 * The current LGC (Legal Guarantee Classification) code set as stored in
 * session storage.
 * @returns {object} Returns an object containing the LGC data.
 */
function getLgc() {
    const storage = window.sessionStorage.getItem(sessionStorageKeys.lgc);
    return storage !== null ? JSON.parse(DOMPurify.sanitize(storage)) : defaultValues.lgc;
}

/**
 * The current SPID (Source Provider ID) campaign as stored in session
 * storage.
 * @returns {object} Returns an object containing the SPID data.
 */
function getSpid() {
    const storage = window.sessionStorage.getItem(sessionStorageKeys.spid);
    return storage !== null ? JSON.parse(DOMPurify.sanitize(storage)) : defaultValues.spid;
}

function setCat(obj = {}) {
    // Remove session storage item entirely if setting it to null.
    if (obj === null) {
        window.sessionStorage.removeItem(sessionStorageKeys.cat);
        return;
    }

    window.sessionStorage.setItem(sessionStorageKeys.cat, JSON.stringify(obj));

    // Dispatch an event with the new values so components can react to updates.
    dispatchCustomEvent('catChange', obj);
}

function setCell(obj = {}) {
    // Remove session storage item entirely if setting it to null.
    if (obj === null) {
        window.sessionStorage.removeItem(sessionStorageKeys.cell);
        return;
    }

    window.sessionStorage.setItem(sessionStorageKeys.cell, JSON.stringify(obj));

    // Dispatch an event with the new values so components can react to updates.
    dispatchCustomEvent('cellChange', obj);
}

function setLgc(obj = {}) {
    // Remove session storage item entirely if setting it to null.
    if (obj === null) {
        window.sessionStorage.removeItem(sessionStorageKeys.lgc);
        return;
    }

    window.sessionStorage.setItem(sessionStorageKeys.lgc, JSON.stringify(obj));

    // Dispatch an event with the new values so components can react to updates.
    dispatchCustomEvent('lgcChange', obj);
}

function setSpid(obj = {}) {
    // Remove session storage item entirely if setting it to null.
    if (obj === null) {
        window.sessionStorage.removeItem(sessionStorageKeys.spid);
        return;
    }

    window.sessionStorage.setItem(sessionStorageKeys.spid, JSON.stringify(obj));

    // Dispatch an event with the new values so components can react to updates.
    dispatchCustomEvent('spidChange', obj);
}

export {
    getCat,
    getCell,
    getLgc,
    getSpid,
    setCat,
    setCell,
    setLgc,
    setSpid
};
